module.exports = __webpack_public_path__ + "static/img/mb_right.57ce064b.png";